import { getConciliationAccountDisplayNumber } from '../../../../../../utils/conciliationAccountDisplay'
import clsx from 'clsx'
import { Text } from '../../../../../ui'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { formatCurrency, formatDate } from '../../../../../../utils/formatter'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import GlobalContext from '../../../../../../../context/global-context'
import iconoEnlace from '../../../../../../../assets/iconos/iconEnlace.png'
import { bankIcons } from '../../../../../views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import translations from '../../../../../ui/traslation/traslationAdministracion.json'
import { getConciliationDisplayStatus } from '../../../../../../utils/conciliationStatus'

const isCajaPrincipalCuentaMenosUno = item =>
  item?.nombreCuentaBanco === 'Caja Principal' && String(item?.numeroCuentaBanco ?? '') === '-1'

const TableVinCajaPrincipal = ({ onCheckboxChange,
  rows,
  idPrincipal,
  dataLinkage,
  setReloadData,
  resetSlider,
  dataModal,
  modalStatus,
  selectedBankFilter,
  useCajaPrincipal,
  onCurrentData,
  selectedIds,
  setSelectedIds,
  unselectedIds,
  setUnselectedIds,
  selectedCheckboxes,
  setSelectedCheckboxes,
  setSelectedDataByOrigen,
  selectedDataByOrigen,
  onToggle
}) => {
  const { ui, currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [, setData] = useState({})
  const isCajaPrincipal = useCajaPrincipal

  const getSelectionKey = item =>
    item?.idPrincipal ?? item?.id ?? item?.customId ?? 'custom-caja-principal'
  
 const handleCheckboxToggle = (id) => {
    if (useCajaPrincipal && id !== 'custom-caja-principal') return;

    const updatedSelection = {
      ...selectedCheckboxes,
      [id]: !selectedCheckboxes[id],
    };

    const selected = Object.keys(updatedSelection).filter((key) => updatedSelection[key]);
    const finalSelection = useCajaPrincipal ? ['custom-caja-principal'] : selected;

    setSelectedCheckboxes(
      useCajaPrincipal
        ? { 'custom-caja-principal': updatedSelection['custom-caja-principal'] }
        : updatedSelection
    );
    setSelectedIds(finalSelection);
    onCheckboxChange(finalSelection);

    let selectedData = rows.filter(row => finalSelection.includes(row.id));

    if ( useCajaPrincipal && finalSelection.includes('custom-caja-principal') && extraRow ) {
      selectedData = [extraRow];
    }

    onCurrentData(selectedData)
  }

  const obtenerAbreviatura = nombre => {
    return translations.documentosContables[nombre] || nombre
  }

  const obtenerFechaActual = () => {
    const hoy = new Date()
    const dia = String(hoy.getDate()).padStart(2, '0')
    const mes = String(hoy.getMonth() + 1).padStart(2, '0')
    const anio = hoy.getFullYear()
    return `${anio}-${mes}-${dia}`
  }

  const linkageCaja = useMemo(() => {
  if (!dataModal?.linkage) return null;
  return (
    dataModal.linkage.find(isCajaPrincipalCuentaMenosUno) ||
    dataModal.linkage.find(l => l.nombreCuentaBanco === 'Caja Principal') ||
    null
  );
}, [dataModal]);

  const isCobro = ['COBRADO', 'POR COBRAR', 'PARCIALMENTE COBRADO'].includes(modalStatus)
  const isPago = ['PAGADO', 'POR PAGAR', 'PARCIALMENTE PAGADO'].includes(modalStatus)

  const extraRow = useMemo(() => {
    if (!useCajaPrincipal || !dataModal) return null;
    if (linkageCaja) {
      return {
        ...linkageCaja,
        customId: 'custom-caja-principal',
        checkboxId: linkageCaja.id,
        customRow: true,
        _origen: 'caja',
      };
    }

    return {
      id: 'custom-caja-principal',
      customId: 'custom-caja-principal',
      fecha: obtenerFechaActual(),
      nombreCuentaBanco: 'Caja Principal',
      numeroCuentaBanco: '1-1-1-1',
      descripcion: `${isCobro ? 'Cobro' : 'Pago'} ${
        obtenerAbreviatura(dataModal.nombreCuenta)
      } ${dataModal.razonSocial}`,
      montoAbono: 0,
      montoCargo: 0,
      montoEditable: 0,
      status: 'PENDIENTE',
      customRow: true,
      _origen: 'caja',
    };
  }, [useCajaPrincipal, dataModal, isCobro, isPago, linkageCaja]);
  
  useEffect(() => {
    if (!useCajaPrincipal) {
      setSelectedCheckboxes({});
      setSelectedIds([]);
      onCheckboxChange([]);
      onCurrentData([]);
    }
  }, [useCajaPrincipal]);

  useEffect(() => {
    if (!extraRow) return;
    const id = getSelectionKey(extraRow);
    if (!selectedCheckboxes[String(id)]) {
      if (onToggle) {
        onToggle(extraRow)
      } else {
        handleCheckboxToggle(id)
      }
    }
  }, [extraRow?.id, extraRow?.idPrincipal]);


  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'cuentaCorriente' },
    { col: 'Descripción', field: 'descripción' },
    { col: 'Abono', field: 'abono' },
    { col: 'Cargo', field: 'cargo' },
    { col: 'Status', field: 'status' },
    { col: '', field: null},
  ]

  const sortRows = useCallback(() => {
  if (useCajaPrincipal && extraRow) return [extraRow];

  if (!Array.isArray(rows)) return [];

  if (dataLinkage && dataLinkage.length > 0) {
    const match = rows.find(
      r => r.comprobante === dataLinkage[0].comprobante
    );
    return match ? [match] : [];
  }

  return rows;
}, [useCajaPrincipal, extraRow, rows, dataLinkage]);


  useEffect(() => {
    const newSelection = {}
    let hasChanges = false

    // Verificar las filas normales
    rows.forEach((item) => {
        const shouldBeSelected =
        item.seleccionado === true ||
        (item.linkage && dataLinkage && item.linkage.idPrincipal === dataLinkage.idPrincipal)
        if (shouldBeSelected) {
        newSelection[item.id] = true
        hasChanges = true
        }
    })

    if (hasChanges && Object.keys(selectedCheckboxes).length === 0) {
    const filteredSelection = Object.entries(newSelection)
      .filter(([id]) => id !== 'custom-caja-principal')  // evitar seleccionar extraRow
      .reduce((acc, [id, val]) => {
        acc[id] = val
        return acc
      }, {})

    setSelectedCheckboxes(filteredSelection)
    const selected = Object.keys(filteredSelection)
    setSelectedIds(selected)
    onCheckboxChange(selected)
    }
  }, [rows, dataLinkage])
  
  const handleDesvincular = async (ids = selectedIds) => {
    const numericIds = Array.from(
      new Set(
        (Array.isArray(ids) ? ids : [])
          .map(Number)
          .filter(Number.isFinite)
      )
    )
    if (numericIds.length === 0) return
    const payload = { ids: numericIds }
    try {
    ui.setLoader({ visible: true})
    const response = await organizationAPI.postDesvincular({
        businessId: currentBusiness.id, 
        idLibro: idPrincipal,
    }, payload)
    setData(response)
    setSelectedCheckboxes({})
    setSelectedIds([])
    if (setReloadData) setReloadData(prev => !prev)
    } catch (error) {
    console.error(error)
    } finally {
      ui.setLoader({ visible: false})
    }
  }

  const getCleanStatus = row =>
      typeof row?.status === 'string'
        ? row.status.replace(/\s*undefined\s*/gi, '').trim()
        : ''
  
  const normalizeStatus = status =>
      String(status || '')
        .replace(/\s*undefined\s*/gi, '')
        .trim()
        .toUpperCase()
  
    const statusTone = status => {
      const s = normalizeStatus(status)
      if (s.includes('PARCIAL')) return 'warning'
      if (s.includes('CONCILIADO') || s.includes('PAGADO') || s.includes('COBRADO')) return 'success'
      if (s.includes('PENDIENTE')) return 'danger'
      if (s.includes('PARCIAL') && s.includes('ANUL')) return 'muted'
      return 'muted'
    }
  
    const statusBadgeClass = status => {
      const tone = statusTone(status)
      return clsx(
        'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider',
        {
          'text-danger bg-danger/10': tone === 'danger',
          'text-success bg-success/10': tone === 'success',
          'text-amber-700 bg-amber-100': tone === 'warning',
          'text-muted bg-border/40': tone === 'muted'
        }
      )
    }

  if (!rows?.[0] && !isCajaPrincipal) {
  return <Text className='grid place-items-center py-12'>{translations.tableAction.noData}</Text>
  }

  if (isCajaPrincipal) {
    // Tabla simplificada sin filtros ni paginación
    return (
      <div className="flex flex-col h-full">
        <div className="overflow-x-auto flex-1">
          <div className="max-h-96 overflow-y-auto mt-2">
            <table className={styles.table}>
              <thead className={styles.thead}>
                <tr>
                  {orderableCols.map(({ col }, i) => (
                    <th key={i} className={clsx(styles.th, i === 0 && styles.mediumCol)}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={styles.tbody}>
                {sortRows()?.map((item) => {
                  const selectionKey = getSelectionKey(item)
                  const isChecked = !!selectedCheckboxes[String(selectionKey)]
                  const isSeleccionado = item.seleccionado === true
                  const isActive = isChecked || isSeleccionado
                  const isCustom = item.customRow
                  const origen = item._origen;
                  const currentRows = selectedDataByOrigen[origen] || [];
                  const selectedItem = currentRows.find(r => r.id === item.id) || item;
                  const cleanStatus = getCleanStatus(item)
                  const displayStatus = getConciliationDisplayStatus(cleanStatus, modalStatus, isActive)
                  return (
                    <tr key={item.id} className={styles.tr}>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            className='rounded'
                            checked={isChecked}
                            onChange={() => onToggle(item)}
                          />
                          <img src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank} className="min-w-8 h-8" />
                        </div>
                      </td>
                      <td className={clsx(styles.td, styles.smallCol)}>
                        <Text className={styles.boldText}>{formatDate(item.fecha)}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>{item.nombreCuentaBanco}</Text>
                        <Text className={styles.text}>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco)}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>{item.descripcion}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {selectedItem.customRow && isCobro ? (
                          <input
                            type="text"
                            inputMode="numeric"
                            className="border rounded-full text-xs text-right px-1 py-0.5 w-20
                              [appearance:textfield]
                              [&::-webkit-outer-spin-button]:appearance-none
                              [&::-webkit-inner-spin-button]:appearance-none"
                            // mostramos montoEditable para permitir edición en el modal/tbl; si no existe, mostramos montoAbono o 0
                            value={`$ ${Number(selectedItem.montoEditable ?? selectedItem.montoAbono ?? 0).toLocaleString('es-CL')}`}
                            onFocus={e => {
                              // al enfocar mostramos el número crudo para editar
                              e.target.value = String(selectedItem.montoEditable ?? selectedItem.montoAbono ?? 0)
                            }}
                            onBlur={e => {
                              // formatea al perder foco (opcional)
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              e.target.value = `$ ${Number(digits || 0).toLocaleString('es-CL')}`
                            }}
                            onChange={e => {
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              const newValue = Number(digits || 0);
                              const origen = selectedItem._origen;

                              setSelectedDataByOrigen(prev => {
                                const current = prev[origen] || [];
                                const updated = current.map(r =>
                                  r.id === selectedItem.id
                                    ? {
                                        ...r,
                                        montoEditable: newValue, // valor editable compartido
                                        montoAbono: newValue,    // actualizamos sólo abono
                                        montoCargo: 0,           // y dejamos cargo en 0 (como pides)
                                      }
                                    : r
                                );
                                return { ...prev, [origen]: updated };
                              });
                            }}
                          />
                        ) : (
                          <Text className={styles.boldText}>{formatCurrency(selectedItem.montoAbono)}</Text>
                        )}
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {selectedItem.customRow && isPago ? (
                          <input
                            type="text"
                            inputMode="numeric"
                            className="border rounded-full text-xs text-right px-1 py-0.5 w-20
                              [appearance:textfield]
                              [&::-webkit-outer-spin-button]:appearance-none
                              [&::-webkit-inner-spin-button]:appearance-none"
                            value={`$ ${Number(selectedItem.montoEditable ?? selectedItem.montoCargo ?? 0).toLocaleString('es-CL')}`}
                            onFocus={e => {
                              e.target.value = String(selectedItem.montoEditable ?? selectedItem.montoCargo ?? 0)
                            }}
                            onBlur={e => {
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              e.target.value = `$ ${Number(digits || 0).toLocaleString('es-CL')}`
                            }}
                            onChange={e => {
                              const digits = e.target.value.replace(/[^\d]/g, '');
                              const newValue = Number(digits || 0);
                              const origen = selectedItem._origen;

                              setSelectedDataByOrigen(prev => {
                                const current = prev[origen] || [];
                                const updated = current.map(r =>
                                  r.id === selectedItem.id
                                    ? {
                                        ...r,
                                        montoEditable: newValue, // compartido para modal
                                        montoCargo: newValue,    // actualizamos sólo cargo
                                        montoAbono: 0,           // y dejamos abono en 0
                                      }
                                    : r
                                );
                                return { ...prev, [origen]: updated };
                              });
                            }}
                          />
                        ) : (
                          <Text className={styles.boldText}>{formatCurrency(selectedItem.montoCargo)}</Text>
                        )}
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <span className={statusBadgeClass(displayStatus)}>
                          {displayStatus || '—'}
                        </span>
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {!isCustom && (
                          <div className='flex h-full items-center justify-center space-x-3'>
                            <div
                              className={clsx(
                                'flex flex-col text-xs items-center justify-center',
                                !isActive ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:cursor-pointer'
                              )}
                              onClick={() => {
                                if (isActive) {
                                  handleDesvincular([item.realId ?? item.idPrincipal ?? item.id])
                                }
                              }}
                            >
                              <div
                                className={clsx(
                                  'bg-[#fff] flex shadow-full-xs rounded-full items-center justify-center w-9 h-9 transition-colors duration-150',
                                  isActive
                                    ? 'text-slate-400 hover:bg-slate-100/50'
                                    : 'bg-gray-100 text-gray-300'
                                )}
                              >
                                <img src={iconoEnlace} alt="icono enlace" className="w-7 h-7" />
                              </div>
                              <Text className='mt-2'>Desconciliar</Text>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

}

export default TableVinCajaPrincipal
